export enum authProvider {
  CORPORATE = 'corporate',
  CUSTOMER = 'customer',
  NONE = 'none',
}
